/* Flovela Bloom — theme behaviour */
(function () {
  'use strict';

  var cfg = window.flovela || {};
  var routes = window.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Blooming flowers ---------- */
  function openBlooms(root) {
    $$('.bloom', root).forEach(function (svg) { svg.classList.add('is-open'); });
  }

  function initBlooms() {
    $$('[data-bloom-on-load]').forEach(function (el) {
      requestAnimationFrame(function () {
        el.classList.add('is-ready');
        openBlooms(el);
      });
    });

    var onView = $$('[data-bloom-on-view]');
    if (!onView.length) return;
    if (!('IntersectionObserver' in window)) { onView.forEach(openBlooms); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          openBlooms(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35 });
    onView.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Petal burst ---------- */
  function petalBurst(fromEl) {
    if (!cfg.petalBurst || reduceMotion || !fromEl) return;
    var layer = $('.petal-layer');
    if (!layer) return;
    var r = fromEl.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;
    for (var i = 0; i < 14; i++) {
      var p = document.createElement('span');
      p.className = 'burst-petal';
      var angle = (Math.PI * 2 * i) / 14 + (Math.random() - 0.5) * 0.5;
      var dist = 70 + Math.random() * 90;
      p.style.left = cx + 'px';
      p.style.top = cy + 'px';
      p.style.setProperty('--bx', Math.cos(angle) * dist + 'px');
      p.style.setProperty('--by', Math.sin(angle) * dist - 30 + 'px');
      p.style.setProperty('--br', (Math.random() * 540 - 270) + 'deg');
      layer.appendChild(p);
      setTimeout(function (el) { el.remove(); }, 1000, p);
    }
  }

  /* ---------- Mobile nav ---------- */
  function initNav() {
    var toggle = $('[data-nav-toggle]');
    var nav = $('#MobileNav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.hidden = open;
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      var main = $('.product__main-img', gallery);
      if (!main) return;
      $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          $$('[data-gallery-thumb]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          main.classList.add('is-swapping');
          var next = new Image();
          next.onload = function () {
            main.srcset = thumb.dataset.srcset;
            main.src = thumb.dataset.src;
            main.alt = thumb.dataset.alt;
            main.classList.remove('is-swapping');
          };
          next.src = thumb.dataset.src;
        });
      });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    $$('[data-qty]').forEach(function (wrap) {
      var input = $('input', wrap);
      if (!input) return;
      $$('[data-qty-step]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, v + parseInt(btn.dataset.qtyStep, 10));
        });
      });
    });
  }

  /* ---------- Variants ---------- */
  function formatMoney(cents) {
    var amount = cents / 100;
    var str = amount % 1 === 0 ? String(amount) : amount.toFixed(2);
    return '€' + str;
  }

  function initVariants() {
    $$('[data-product-form]').forEach(function (form) {
      var data = $('[data-variants]', form);
      if (!data) return;
      var variants = JSON.parse(data.textContent);
      var idInput = $('[data-variant-id]', form);
      var section = form.closest('[data-product]');
      form.addEventListener('change', function (e) {
        if (!e.target.matches('[data-option-input]')) return;
        var chosen = $$('fieldset.option', form).map(function (fs) {
          var checked = $('input:checked', fs);
          return checked ? checked.value : null;
        });
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });
        if (!match) return;
        idInput.value = match.id;
        var sticker = section && $('[data-price] .sticker', section);
        if (sticker) sticker.textContent = formatMoney(match.price);
        toggleAvailability(form, match.available);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  function toggleAvailability(form, available) {
    var add = $('[data-add-to-cart]', form);
    var pre = $('[data-preorder]', form);
    var sold = $('[data-soldout]', form);
    var note = $('[data-preorder-note]', form);
    if (add) add.hidden = !available;
    if (pre) pre.hidden = available;
    if (sold) sold.hidden = available;
    if (note) note.hidden = available;
  }

  /* ---------- Cart drawer ---------- */
  var drawer;
  var lastFocus;

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', Number(count) === 0);
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  }

  function renderDrawer(html) {
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.drawer__panel');
    var current = $('.drawer__panel', drawer);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var src = $('[data-cart-count-source]', drawer);
    if (src) updateCount(src.textContent.trim());
  }

  function openDrawer() {
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var panel = $('.drawer__panel', drawer);
    if (panel) setTimeout(function () { panel.focus(); }, 50);
    return true;
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function initDrawer() {
    drawer = $('[data-cart-drawer]');
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && drawer && cfg.cartType === 'drawer') {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest('[data-cart-close]')) {
        var link = e.target.closest('a[data-cart-close]');
        if (!link) e.preventDefault();
        closeDrawer();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  function changeLine(line, quantity) {
    var body = drawer && $('[data-cart-contents]', drawer);
    if (body) body.classList.add('is-busy');
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if ($('[data-cart-page]')) { window.location.reload(); return; }
        if (cart.sections) renderDrawer(cart.sections['cart-drawer']);
        else updateCount(cart.item_count);
      })
      .catch(function () { window.location.href = routes.cart; });
  }

  function initLineChanges() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-line-change]');
      if (!btn) return;
      e.preventDefault();
      changeLine(btn.dataset.lineChange, btn.dataset.lineQty);
    });
  }

  /* ---------- Add to bag ---------- */
  function initAddToCart() {
    $$('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        var button = $('[data-add-to-cart]', form);
        var label = $('[data-add-label]', form);
        var errorBox = $('[data-form-error]', form);
        var original = label ? label.textContent : '';
        if (button) button.classList.add('is-loading');
        if (label) label.textContent = 'Adding…';
        if (errorBox) errorBox.hidden = true;

        var fd = new FormData(form);
        if (drawer) fd.append('sections', 'cart-drawer');

        fetch(routes.cartAdd + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add this bouquet.');
            petalBurst(button);
            if (label) label.textContent = 'Added';
            if (cfg.cartType === 'drawer' && drawer && res.body.sections) {
              renderDrawer(res.body.sections['cart-drawer']);
              setTimeout(openDrawer, reduceMotion ? 0 : 450);
            } else {
              setTimeout(function () { window.location.href = routes.cart; }, reduceMotion ? 0 : 500);
            }
          })
          .catch(function (err) {
            if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
          })
          .finally(function () {
            if (button) button.classList.remove('is-loading');
            setTimeout(function () { if (label) label.textContent = original; }, 1400);
          });
      });
    });
  }

  /* ---------- Contact form: prefill the bouquet name for pre-orders ---------- */
  function initPrefill() {
    var field = $('[data-prefill-bouquet]');
    if (!field || field.value) return;
    var name = new URLSearchParams(window.location.search).get('bouquet');
    if (name) field.value = name;
  }

  function init() {
    initBlooms();
    initNav();
    initGallery();
    initQty();
    initVariants();
    initDrawer();
    initLineChanges();
    initAddToCart();
    initPrefill();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) { openBlooms(e.target); });
})();
